export const ErrorCategories = {
  drm: 'drm',
  license: 'license',
  network: 'network',
  default: 'player',
};

// Wrap shaka.util.Error into real Error
// see https://shaka-player-demo.appspot.com/docs/api/lib_util_error.js.html#line35
export class ShakaError extends Error {
  constructor(shakaError) {
    super(`code ${shakaError.code}`);

    this.name = 'ShakaError';

    this.severity = shakaError.severity;
    this.category = shakaError.category;
    this.code = shakaError.code;
    this.data = shakaError.data;
    this.handled = shakaError.handled;
  }
}
